<template>
  <div class="main" v-bind:style="{ backgroundImage: 'url(' + dlbj_image + ')' }">
    <!-- 手机扫码登录和账号密码登录 -->
    <div class="loginBox">
      <div v-if="cainiao_logo">
        <img :src="logo_image" />
      </div>
      <div v-if="qnp_logo">
        <img :src="qnp_logo_img" style="height: 65px" />
      </div>
      <div v-if="!cainiao_logo && !qnp_logo && ruyi_logo" class="box_head">
        <img
          :src="ruyi_logo_img"
          style="height: 70px; margin-left: 40px; float: left"
          alt="Logo"
        />
      </div>
      <div v-if="ty_logo" class="box_head">
        <img
          :src="ty_logo_img"
          style="height: 70px; margin-left: 20px; float: left"
          alt="Logo"
        />
        <div style="margin-top: -56px; margin-left: 90px; float: left">{{ siteName }}</div>
      </div>
      <!-- <div style="font-size: 16px">注册</div> -->
      <div class="form">
        <el-form
          :model="registerForm"
          :rules="registerRules"
          ref="registerForm"
          label-width="0px"
        >
          <el-form-item prop="phone">
            <el-input
              v-model="registerForm.phone"
              placeholder="请输入手机号"
              prefix-icon="el-icon-mobile-phone"
            ></el-input>
          </el-form-item>
          <el-form-item prop="code">
            <el-input
              v-model="registerForm.code"
              placeholder="请输入验证码"
              prefix-icon="el-icon-chat-line-round"
            ></el-input>
            <!-- <a type="button" @click="sendCode">获取验证码</a> -->
            <a type="button" @click="sendCode" :disabled="countdown > 0">
              {{ countdown > 0 ? `${countdown}秒后重新获取` : "获取验证码" }}
            </a>
          </el-form-item>
          <el-form-item prop="name">
            <el-input
              v-model="registerForm.name"
              placeholder="用户名"
              prefix-icon="el-icon-user"
            ></el-input>
          </el-form-item>
          <el-form-item prop="email">
            <el-input
              v-model="registerForm.email"
              placeholder="邮箱"
              prefix-icon="el-icon-user"
            ></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              v-model="registerForm.password"
              placeholder="密码"
              show-password
              prefix-icon="el-icon-lock"
            ></el-input>
          </el-form-item>
          <el-form-item prop="password_confirmation">
            <el-input
              v-model="registerForm.password_confirmation"
              placeholder="确认密码"
              show-password
              prefix-icon="el-icon-lock"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              @click="submitForm('registerForm')"
              type="primary"
              style="background-color: #0850fc"
              >注册</el-button
            >
          </el-form-item>
        </el-form>

        <!-- <div style="color: #0850fc; padding-top: 15px">注册账号</div> -->
        <el-button
          @click="toLogin"
          type="primary"
          style="
            background-color: white;
            color: #0850fc;
            margin-top: 10px;
            padding: 0;
            border: 0px solid white;
            width: 77px;
          "
          >登录账号</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import qs from "qs";
import Cookies from "js-cookie";
import "@/assets/custom-theme/index.css";
Vue.prototype.$qs = qs;

export default {
  name: "register",
  data() {
    return {
      registerForm: {
        phone: "",
        code: "",
        name: "",
        email: "",
        password: "",
        password_confirmation: "",
      },
      registerRules: {
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { pattern: /^1[3456789]\d{9}$/, message: "手机号格式错误", trigger: "blur" },
        ],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        name: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        email: [{ required: true, message: "请输入邮箱", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        password_confirmation: [
          { required: true, message: "请确认密码", trigger: "blur" },
        ],
      },
      logo_image: require("@/assets/cnyc_logo.png"),
      dlbj_image: require("@/assets/dlbj.jpg"),
      cainiao_logo: false,
      countdown: 0, // 倒计时时间
      regUrl: "",
      regUid: "",
      siteName: "",
      ruyi_logo_img: require("@/assets/ruyi_logo.png"),
      ruyi_logo: false,
      qnp_logo: false,
      qnp_logo_img: require("@/assets/qnp_logo.png"),
      ty_logo: false,
      ty_logo_img: require("@/assets/cnyc_logo2.png"),
    };
  },
  async created() {
    // 获取系统信息并设置logo
    const systemInfo = await this.$root.getSystemInfo();
    if (systemInfo && systemInfo.site_name) {
      this.setLogoBySiteName(systemInfo.site_name);
    }
    
    this.regUrl = window.location.href.split("/")[2];
    this.regUid = window.location.href.split("?uid=")[1];
  },
  methods: {
    setLogoBySiteName(siteName) {
      // 先重置所有logo标志
      this.cainiao_logo = false;
      this.qnp_logo = false;
      this.ruyi_logo = false;
      this.ty_logo = false;
      
      const sn = siteName || Cookies.get("view_site_name");
      if (sn == "菜鸟云仓" || sn == "菜鸟云仓test") {
        this.cainiao_logo = true;
      } else if (sn == "全能拍云仓") {
        this.qnp_logo = true;
      } else if (sn == "如意云仓") {
        this.ruyi_logo = true;
      } else if (sn && sn != "undefined" && sn != "null") {
        this.ty_logo = true;
        this.siteName = sn;
      }
    },
    //注册
    async submitForm(formName) {
      let system_id = Cookies.get("view_system_id");
      if (system_id == "" || system_id == null || system_id == undefined) {
        await this.$root.getSystemInfo();
      }
      system_id = Cookies.get("view_system_id");
      if (system_id == "" || system_id == null || system_id == undefined) {
        this.$confirm("获取系统信息失败，请刷新重试！", "提示", {
          confirmButtonText: "确认",
          showCancelButton: false, //是否显示取消按钮
        })
          .then(() => {})
          .catch(() => {});

        location.reload();
        return;
      }

      this.$refs[formName].validate((valid) => {
        if (valid) {
          let sendData = {
            phone: this.registerForm.phone,
            code: this.registerForm.code,
            name: this.registerForm.name,
            email: this.registerForm.email,
            password: this.registerForm.password,
            password_confirmation: this.registerForm.password_confirmation,
            uid: this.regUid,
            // url: this.regUrl,
            // url: "cs.cainiaolipin.cn",
            system_id: system_id,
          };
          let registerUrl = this.$root.commonPreUrl + "/index/create";

          const res = axios.post(registerUrl, sendData);
          res
            .then((response) => {
              const code = response.data.code;
              if (code == 200) {
                const userToken = response.data.token;
                Cookies.set("view_userToken", userToken, { expires: 1 });
                // 调用当前用户信息
                this.$root.getUserInfo();
                this.$root.getSystemInfo();
                this.$router.push("/");
                // "注册成功！即将跳转登录页面，可登录后使用。：" + response.data.msg,
                // this.$router.push("/login");
                // this.$confirm("注册成功！即将跳转登录页面，可登录后使用", "提示", {
                //   confirmButtonText: "确认",
                //   showCancelButton: false, //是否显示取消按钮
                // })
                //   .then(() => {
                //     this.$router.push({ path: "/login" });
                //   })
                //   .catch(() => {});
              } else {
                // alert("注册失败！原因：" + response.data.msg);
                this.$confirm(
                  "注册失败！原因：" + JSON.stringify(response.data.msg),
                  "提示",
                  {
                    confirmButtonText: "确认",
                    showCancelButton: false, //是否显示取消按钮
                  }
                )
                  .then(() => {
                    return;
                  })
                  .catch(() => {});
              }
            })
            .catch((error) => {
              console.error("初始请求失败:", error);
              this.$confirm("操作失败！请稍后刷新重试。", "提示", {
                confirmButtonText: "确认",
                showCancelButton: false, //是否显示取消按钮
              })
                .then(() => {
                  // 重新导航到首页
                  // localStorage.clear();
                  // this.$root.removeCookies();
                  // this.$router.push({ path: "/login" });
                })
                .catch(() => {});
            });
        } else {
          return false;
        }
      });
    },
    toLogin() {
      this.$router.push({ path: "/login" });
    },
    sendCode() {
      if (this.countdown > 0) {
        return;
      }
      let phoneNum = this.registerForm.phone;
      if (phoneNum == "" || phoneNum == null) {
        // alert("请输入手机号！");
        this.$confirm("请输入手机号！：", "提示", {
          confirmButtonText: "确认",
          showCancelButton: false, //是否显示取消按钮
        })
          .then(() => {
            return;
          })
          .catch(() => {});
        return;
      }
      //    const url = this.$root.commonPreUrl + "/sendCode";
      const url = this.$root.commonPreUrl + "/sendVerificationCode";
      const res = axios.get(url, {
        params: { phone: phoneNum },
      });
      res
        .then((response) => {
          const resd = response.data;
          if (resd.code == "200") {
            // 设置倒计时时间，这里设置为60秒
            this.countdown = 60;
            // 创建倒计时
            const intervalId = setInterval(() => {
              if (this.countdown > 0) {
                this.countdown -= 1;
              } else {
                clearInterval(intervalId);
              }
            }, 1000);
          } else {
            this.$confirm(
              "发送失败！原因：" + JSON.stringify(response.data.message),
              "提示",
              {
                confirmButtonText: "确认",
                showCancelButton: false, //是否显示取消按钮
              }
            )
              .then(() => {
                return;
              })
              .catch(() => {});
          }
          setTimeout(() => {
            return;
          }, 1.5 * 1000);
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          this.$confirm("操作失败！请稍后刷新重试。", "提示", {
            confirmButtonText: "确认",
            showCancelButton: false, //是否显示取消按钮
          })
            .then(() => {
              // 重新导航到首页
              localStorage.clear();
              this.$root.removeCookies();
              this.$router.push({ path: "/login" });
            })
            .catch(() => {});
          return;
        });
    },
  },
};
</script>
<style scoped>
.main {
  width: 100%;
  height: 100vh;
  /* background-color: #eaebf3; */
  /* background-image: url("dlbj_image"); */
  font-weight: bold;

  /*背景布局 按轴方向*/
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.loginBox {
  background-color: #ffffff;
  box-shadow: 0 1px 3px rgba(26, 26, 26, 0.1);
  border-radius: 1em;
  width: 400px;
  /* height: 415px; */
  padding: 20px 40px;
}
.box_head {
  text-align: center;
  height: 70px;
  /* padding-top: 10px; */
  font-size: 36px;
  font-weight: bold;
}
.form {
  margin-top: 15px;
}
.form ul {
  margin: 0;
  padding: 0;
}
.form ul li {
  display: flex;
  flex-direction: column; /*垂直布局*/
}
.el-button {
  width: 100%;
  /* height: 100%; */
}
.el-input {
  position: relative;
}
.form a {
  position: absolute;
  text-decoration: none;
  right: 10px;
  color: #a9a9a9;
  border-left: 1px solid #ccc;
  align-items: center;
  padding-left: 10px;
}
.image {
  height: 60%;
  width: 60%;
}
</style>



// WEBPACK FOOTER //
// src/views/register/index.vue